(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const cartForm = document.getElementById('cart-form');
  const PROMISE_HANDLE = 'the-sew-sweet-promise';

  // Address cart lines by their stable KEY, never by position — the hidden $0 promise
  // occupies a real cart line, so position-based addressing would target the wrong item.
  function realCount(cart) {
    return cart.items.filter(i => i.handle !== PROMISE_HANDLE).reduce((n, i) => n + i.quantity, 0);
  }
  function promiseLine(cart) {
    return cart.items.find(i => i.handle === PROMISE_HANDLE) || null;
  }

  // Quantity stepper buttons
  document.querySelectorAll('.quantity-stepper__btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const input = btn.closest('.quantity-stepper').querySelector('.quantity-stepper__input');
      const key = btn.closest('.cart-item').dataset.key;
      const current = parseInt(input.value) || 0;
      const newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      input.value = newQty;
      await updateCartLineByKey(key, newQty);
    });
  });

  // Direct input change
  document.querySelectorAll('.quantity-stepper__input').forEach(input => {
    input.addEventListener('change', async () => {
      const key = input.closest('.cart-item').dataset.key;
      const qty = Math.max(0, parseInt(input.value) || 0);
      input.value = qty;
      await updateCartLineByKey(key, qty);
    });
  });

  // Remove links — handle via JS by key (don't rely on the line-based href)
  document.querySelectorAll('.cart-item__remove').forEach(link => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      const row = link.closest('.cart-item');
      if (row) await updateCartLineByKey(row.dataset.key, 0);
    });
  });

  async function changeByKey(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.ok ? res.json() : null;
  }

  async function updateCartLineByKey(key, quantity) {
    try {
      let cart = await changeByKey(key, quantity);
      if (!cart) return;

      // When the last real item is gone, drop the $0 promise too and show the empty state.
      if (realCount(cart) === 0) {
        const p = promiseLine(cart);
        if (p) await changeByKey(p.key, 0);
        window.location.reload();
        return;
      }

      // Update subtotal and total (both show same value in this theme)
      document.querySelectorAll('.cart-summary__row span:last-child, .cart-summary__total span:last-child').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });

      // Update item count in page heading (real items only — exclude the promise)
      const countEl = document.querySelector('.cart-page__count');
      if (countEl) {
        const rc = realCount(cart);
        countEl.textContent = '(' + rc + (rc === 1 ? ' item)' : ' items)');
      }

      const row = document.querySelector('.cart-item[data-key="' + key + '"]');
      if (quantity === 0) {
        if (row) row.remove();
      } else if (row) {
        const li = cart.items.find(i => i.key === key);
        if (li) {
          const price = formatMoney(li.line_price);
          const totalEl = row.querySelector('.cart-item__total');
          const mobileEl = row.querySelector('.cart-item__price-mobile');
          if (totalEl) totalEl.textContent = price;
          if (mobileEl) mobileEl.textContent = price;
        }
      }
    } catch (err) {
      console.error('Cart update failed:', err);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.product-card__atc').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.productId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1,
            // trust bullets ride on the line item -> they show on the checkout page.
            // JSON.stringify drops the key entirely when the global isn't set.
            properties: window.SSMD_INCLUDES ? { Includes: window.SSMD_INCLUDES } : undefined })
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }, 1500);
        } else {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }
      } catch {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuBtn = document.querySelector('.site-header__mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const iconOpen = menuBtn?.querySelector('.icon-open');
  const iconClose = menuBtn?.querySelector('.icon-close');

  menuBtn?.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', isOpen);
    mobileMenu.setAttribute('aria-hidden', !isOpen);
    iconOpen.style.display = isOpen ? 'none' : '';
    iconClose.style.display = isOpen ? '' : 'none';
  });

  document.querySelectorAll('.mobile-menu__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.closest('.mobile-menu__item').querySelector('.mobile-menu__sub');
      const isOpen = sub?.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  document.querySelectorAll('.accordion-item h2').forEach(function(heading) {
    heading.style.cursor = 'pointer';
    heading.addEventListener('click', function() {
      var content = heading.nextElementSibling;
      var span = heading.querySelector('span');
      var isOpen = content.style.display !== 'none';
      content.style.display = isOpen ? 'none' : 'block';
      if (span) span.textContent = isOpen ? '+' : '−';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // ── Gallery thumbnails ──
  const galleryScroll = document.getElementById('gallery-scroll');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const dots = document.querySelectorAll('.gallery-dot');

  // ── Thumb-row arrow buttons (compact gallery only) ──
  const thumbRow = document.querySelector('.product-gallery__thumbs-wrap--has-arrows .product-gallery__thumbs');
  const prevBtn = document.querySelector('.product-gallery__thumb-arrow--prev');
  const nextBtn = document.querySelector('.product-gallery__thumb-arrow--next');
  if (thumbRow && prevBtn && nextBtn) {
    const step = () => Math.max(thumbRow.clientWidth - 80, 120);
    const updateArrows = () => {
      prevBtn.disabled = thumbRow.scrollLeft <= 2;
      nextBtn.disabled = thumbRow.scrollLeft + thumbRow.clientWidth >= thumbRow.scrollWidth - 2;
    };
    prevBtn.addEventListener('click', () => thumbRow.scrollBy({ left: -step(), behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => thumbRow.scrollBy({ left: step(), behavior: 'smooth' }));
    thumbRow.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function setActiveIndex(index) {
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const index = parseInt(thumb.dataset.index);
      const slides = galleryScroll.querySelectorAll('.product-gallery__slide');
      slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      setActiveIndex(index);
    });
  });

  // Update active thumb + dots on scroll
  galleryScroll?.addEventListener('scroll', () => {
    const scrollLeft = galleryScroll.scrollLeft;
    const slideWidth = galleryScroll.offsetWidth;
    const index = Math.round(scrollLeft / slideWidth);
    setActiveIndex(index);
  }, { passive: true });

  // ── Quantity stepper ──
  document.querySelector('.quantity-stepper__minus')?.addEventListener('click', () => {
    const input = document.querySelector('.quantity-stepper__input');
    if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
  });
  document.querySelector('.quantity-stepper__plus')?.addEventListener('click', () => {
    const input = document.querySelector('.quantity-stepper__input');
    input.value = parseInt(input.value) + 1;
  });

  // ── Swatch fetch + render ──
  // #swatch-grid = the product's own sub-collection (or full parent if no sub).
  // #swatch-grid-all = the rest of the parent collection (excludes the sub-collection).
  const swatchGrid = document.getElementById('swatch-grid');
  const swatchGridAll = document.getElementById('swatch-grid-all');

  // Swatch image URL is chosen server-side (by alt=="swatch") in the collection.swatch-data
  // view, because the legacy products.json endpoint strips image alt text.
  function buildSwatch(product, currentProductId) {
    const imgSrc = product.swatch || null;
    const isActive = product.id === currentProductId;
    const a = document.createElement('a');
    a.href = `/products/${product.handle}`;
    a.className = `product-swatch${isActive ? ' product-swatch--active' : ''}`;
    a.title = product.title;
    a.setAttribute('aria-label', product.title);
    if (isActive) a.setAttribute('aria-current', 'page');
    if (imgSrc) {
      const img = document.createElement('img');
      img.src = imgSrc;
      img.alt = product.title;
      img.width = 300;
      img.loading = 'lazy';
      a.appendChild(img);
    } else {
      const span = document.createElement('span');
      span.className = 'product-swatch__placeholder';
      a.appendChild(span);
    }
    return a;
  }

  // Fetch every product (across all paginated pages) from the swatch-data JSON view.
  function fetchSwatchProducts(handle) {
    function page(p) {
      return fetch(`/collections/${handle}?view=swatch-data&page=${p}`).then(r => r.json());
    }
    return page(1).then((first) => {
      const pages = first.pages || 1;
      if (pages <= 1) return first.products || [];
      const rest = [];
      for (let p = 2; p <= pages; p++) rest.push(page(p));
      return Promise.all(rest).then((more) =>
        (first.products || []).concat.apply(first.products || [], more.map(m => m.products || []))
      );
    });
  }

  if (swatchGrid) {
    const currentProductId = parseInt(swatchGrid.dataset.productId);
    const firstHandle = swatchGrid.dataset.collection;
    const subIds = new Set();

    fetchSwatchProducts(firstHandle)
      .then((products) => {
        products.forEach((product) => {
          subIds.add(product.id);
          swatchGrid.appendChild(buildSwatch(product, currentProductId));
        });

        // Second grid: rest of the parent collection, excluding the sub-collection above
        if (swatchGridAll) {
          const parentHandle = swatchGridAll.dataset.collection;
          fetchSwatchProducts(parentHandle)
            .then((allProducts) => {
              allProducts
                .filter(p => !subIds.has(p.id))
                .forEach(p => swatchGridAll.appendChild(buildSwatch(p, currentProductId)));
            });
        }
      });
  }

  // ── Variant selection ──
  // Load pre-formatted variant prices from server-rendered JSON
  const variantPriceData = JSON.parse(document.getElementById('variant-price-data').textContent);

  function getSelectedVariantId() {
    const o1 = document.querySelector('[data-option-position="1"]:checked')?.value || null;
    const o2 = document.querySelector('[data-option-position="2"]:checked')?.value || null;
    const o3 = document.querySelector('[data-option-position="3"]:checked')?.value || null;
    for (const [id, v] of Object.entries(variantPriceData)) {
      if (v.option1 === o1 && v.option2 === o2 && v.option3 === o3) return id;
    }
    return null;
  }

  document.querySelectorAll('.product-option__input').forEach(input => {
    input.addEventListener('change', () => {
      // Update selected label text
      const position = input.dataset.optionPosition;
      const selectedSpan = document.getElementById('option-selected-' + position);
      if (selectedSpan) {
        var nm = input.value.split('(')[0].trim();
        const dims = input.value.includes('(')
          ? input.value.split('(')[1].replace(')', '').trim()
          : '';
        selectedSpan.textContent = dims ? (nm + ' (' + dims + ' inches)') : nm;
      }

      const variantId = getSelectedVariantId();
      if (!variantId) return;
      const v = variantPriceData[variantId];

      // Update hidden variant ID for form submission
      const variantInput = document.getElementById('variant-id');
      if (variantInput) variantInput.value = variantId;

      // Show the SALE ribbon only while a discounted size is selected
      const saleRibbon = document.getElementById('pdp-sale-ribbon');
      if (saleRibbon) saleRibbon.hidden = !v.compareAtPrice;

      // Update price display using Shopify-formatted prices
      const priceDisplay = document.getElementById('price-display');
      if (priceDisplay) {
        priceDisplay.textContent = '';
        if (v.compareAtPrice) {
          const wasSpan = document.createElement('span');
          wasSpan.className = 'product-info__price-was';
          wasSpan.textContent = v.compareAtPrice;
          priceDisplay.appendChild(wasSpan);
          priceDisplay.appendChild(document.createTextNode(' ' + v.price));
        } else {
          priceDisplay.textContent = v.price;
        }
      }

      // Update sticky ATC price
      const stickyPrice = document.getElementById('sticky-price');
      if (stickyPrice) stickyPrice.textContent = v.price;

      // Update Shop Pay installment amount (price / 4)
      const installmentEl = document.getElementById('installment-amount');
      if (installmentEl && v.installment) installmentEl.textContent = v.installment;

      // Update ATC button availability
      const atcBtn = document.getElementById('add-to-cart-btn');
      const stickyBtn = document.getElementById('sticky-atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        stickyBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }

      // Sync gallery to the resolved variant's image (skip if same image already showing)
      const variantImageId = v.featuredImageId;
      if (variantImageId && galleryScroll) {
        const targetSlide = galleryScroll.querySelector(`[data-image-id="${variantImageId}"]`);
        if (targetSlide) {
          const index = parseInt(targetSlide.dataset.index);
          const currentActive = document.querySelector('.product-gallery__thumb.is-active');
          const alreadyShown = currentActive && parseInt(currentActive.dataset.index) === index;
          if (!alreadyShown) {
            targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            setActiveIndex(index);
          }
        }
      }
    });
  });

  // Re-clicking the already-selected value fires no 'change', so the gallery stayed on the
  // lifestyle image (e.g. Fijn cocoa's default flavor). Jump to the variant image on re-click.
  // Added 2026-10-28.
  const lastChecked = {};
  document.querySelectorAll('.product-option__input:checked').forEach(i => { lastChecked[i.name] = i; });
  document.querySelectorAll('.product-option__input').forEach(input => {
    input.addEventListener('click', () => {
      const reclick = lastChecked[input.name] === input;
      lastChecked[input.name] = input;
      if (!reclick || !galleryScroll) return;
      const v = variantPriceData[getSelectedVariantId()];
      const targetSlide = v && v.featuredImageId && galleryScroll.querySelector(`[data-image-id="${v.featuredImageId}"]`);
      if (targetSlide) {
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActiveIndex(parseInt(targetSlide.dataset.index));
      }
    });
  });

  // Scroll to reviews when rating count is clicked
  document.querySelector('.product-info__rating-count')?.addEventListener('click', () => {
    document.getElementById('product-reviews')?.scrollIntoView({ behavior: 'smooth' });
  });

  // ── "You may also like" carousel arrows ──
  const relTrack = document.getElementById('related-track');
  const relPrev = document.getElementById('related-prev');
  const relNext = document.getElementById('related-next');
  if (relTrack && relPrev && relNext) {
    const relStep = () => {
      const card = relTrack.querySelector('.related-card');
      const cardW = card ? card.getBoundingClientRect().width + 20 : 300;
      // advance by as many whole cards as are visible (min 1)
      return Math.max(Math.floor(relTrack.clientWidth / cardW), 1) * cardW;
    };
    const relUpdate = () => {
      relPrev.disabled = relTrack.scrollLeft <= 2;
      relNext.disabled = relTrack.scrollLeft + relTrack.clientWidth >= relTrack.scrollWidth - 2;
    };
    relPrev.addEventListener('click', () => relTrack.scrollBy({ left: -relStep(), behavior: 'smooth' }));
    relNext.addEventListener('click', () => relTrack.scrollBy({ left: relStep(), behavior: 'smooth' }));
    relTrack.addEventListener('scroll', relUpdate, { passive: true });
    window.addEventListener('resize', relUpdate);
    relUpdate();
  }

  // ── Scroll-in reveal: heading fades in, cards slide in from the right ──
  // Uses a scroll + requestAnimationFrame check rather than IntersectionObserver: on iOS Safari
  // IO frequently doesn't fire until momentum scrolling settles, which made the reveal unreliable.
  // scroll events + rAF fire dependably across devices.
  const relSection = document.querySelector('.product-related');
  if (relSection) {
    relSection.classList.add('reveal-ready'); // gate the hidden state on JS being present
    const relTitle = relSection.querySelector('.product-related__title');
    const relCarousel = relSection.querySelector('.related-carousel');
    const vhNow = () => window.innerHeight || document.documentElement.clientHeight;
    // Re-triggerable reveal that won't "buzz": we track in/out state explicitly and only act on a real
    // transition. Adding when it enters, removing only once it's clearly off-screen (with a 60px buffer
    // so iOS address-bar resize / scroll jitter near the edge can't flip it and restart the animation).
    const BUF = 60;
    let titleIn = false, cardsIn = false;
    const relToggle = (el, enterRatio, isIn) => {
      if (!el) return isIn;
      const r = el.getBoundingClientRect();
      const vh = vhNow();
      if (!isIn && r.top < vh * enterRatio && r.bottom > 0) {
        el.classList.add('is-in');                 // entering view → animate in (once per entrance)
        return true;
      }
      if (isIn && (r.bottom <= -BUF || r.top >= vh + BUF)) {
        el.classList.remove('is-in');              // clearly off-screen → re-arm for next time
        return false;
      }
      return isIn;
    };
    const relCheck = () => {
      titleIn = relToggle(relTitle, 0.92, titleIn);
      cardsIn = relToggle(relCarousel || relSection, 0.72, cardsIn);
    };
    let relTick = false;
    const relOnScroll = () => {
      if (relTick) return;
      relTick = true;
      requestAnimationFrame(() => { relTick = false; relCheck(); });
    };
    window.addEventListener('scroll', relOnScroll, { passive: true });
    window.addEventListener('resize', relOnScroll, { passive: true });
    relCheck(); // in case the section is already in view on load
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('.product-card__atc').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.productId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1,
            // trust bullets ride on the line item -> they show on the checkout page.
            // JSON.stringify drops the key entirely when the global isn't set.
            properties: window.SSMD_INCLUDES ? { Includes: window.SSMD_INCLUDES } : undefined })
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          setTimeout(() => { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 1500);
        } else {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }
      } catch { btn.disabled = false; btn.textContent = 'Add to Cart'; }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssmd-collection-hub"]) return;
  try {
    
  function scrollCarousel(id, direction) {
    var carousel = document.getElementById(id);
    if (!carousel) return;
    carousel.scrollBy({ left: direction * 280, behavior: 'smooth' });
  }

  document.querySelectorAll('.product-card__atc').forEach(function(btn) {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      var variantId = btn.dataset.productId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1,
            // trust bullets ride on the line item -> they show on the checkout page.
            // JSON.stringify drops the key entirely when the global isn't set.
            properties: window.SSMD_INCLUDES ? { Includes: window.SSMD_INCLUDES } : undefined })
        });
        btn.textContent = res.ok ? 'Added!' : 'Add to Cart';
        if (res.ok) setTimeout(function() { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 1500);
        else btn.disabled = false;
      } catch {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssmd-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth > 768) return;
    const grid = document.querySelector('.featured-products__grid');
    const dotsContainer = document.getElementById('fp-dots');
    if (!grid || !dotsContainer) return;
    const cards = grid.querySelectorAll('.fp-slide');
    if (cards.length < 2) return;

    let current = 0;
    let touchStartX = 0;

    cards.forEach(function(_, i) {
      const dot = document.createElement('span');
      dot.className = 'fp-dot' + (i === 0 ? ' fp-dot--active' : '');
      dot.addEventListener('click', function() { goTo(i); });
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll('.fp-dot');

    var prevBtn = document.getElementById('fp-prev');
    var nextBtn = document.getElementById('fp-next');

    function goTo(index) {
      current = Math.max(0, Math.min(index, cards.length - 1));
      grid.style.transform = 'translateX(-' + (current * cards[0].offsetWidth) + 'px)';
      dots.forEach(function(d, i) { d.classList.toggle('fp-dot--active', i === current); });
      if (prevBtn) prevBtn.classList.toggle('fp-arrow--hidden', current === 0);
      if (nextBtn) nextBtn.classList.toggle('fp-arrow--hidden', current === cards.length - 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    goTo(0);

    grid.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    grid.addEventListener('touchend', function(e) {
      const delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) goTo(current + (delta > 0 ? 1 : -1));
    }, { passive: true });
  });

  // Quick add to cart
  document.querySelectorAll('.product-card__atc').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.productId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1,
            // trust bullets ride on the line item -> they show on the checkout page.
            // JSON.stringify drops the key entirely when the global isn't set.
            properties: window.SSMD_INCLUDES ? { Includes: window.SSMD_INCLUDES } : undefined })
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }, 1500);
        } else {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }
      } catch {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssmd-page-gift-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-card__atc').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.productId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1,
            // trust bullets ride on the line item -> they show on the checkout page.
            // JSON.stringify drops the key entirely when the global isn't set.
            properties: window.SSMD_INCLUDES ? { Includes: window.SSMD_INCLUDES } : undefined })
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }, 1500);
        }
      } catch {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssmd-vip-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('vip-signup-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var firstName = form.querySelector('#vip-first-name').value.trim();
      var lastName = form.querySelector('#vip-last-name').value.trim();
      var email = form.querySelector('#vip-email').value.trim();
      var phone = form.querySelector('#vip-phone').value.trim();
      var submitBtn = document.getElementById('vip-submit-btn');
      var errorEl = document.getElementById('vip-error');
      var errorMsg = document.getElementById('vip-error-msg');

      if (!firstName || !lastName || !email) {
        errorEl.style.display = 'block';
        errorMsg.textContent = 'Please fill in your first name, last name, and email.';
        return;
      }

      submitBtn.disabled = true;
      submitBtn.querySelector('.vip-signup__btn-text').style.display = 'none';
      submitBtn.querySelector('.vip-signup__btn-loading').style.display = 'inline';
      errorEl.style.display = 'none';

      var profileAttrs = {
        email: email,
        first_name: firstName,
        last_name: lastName
      };

      if (phone) {
        profileAttrs.phone_number = phone.replace(/[\s\-\(\)]/g, '').replace(/^(\d{10})$/, '+1$1');
      }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttrs
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'S4jMvt'
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XmwJ8h', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-07-15'
        },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (res.ok || res.status === 202) {
          form.style.display = 'none';
          document.getElementById('vip-success').style.display = 'block';
        } else {
          return res.json().then(function (data) {
            throw new Error(data.errors ? data.errors[0].detail : 'Something went wrong.');
          });
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.querySelector('.vip-signup__btn-text').style.display = 'inline';
        submitBtn.querySelector('.vip-signup__btn-loading').style.display = 'none';
        errorEl.style.display = 'block';
        errorMsg.textContent = err.message || 'Something went wrong. Please try again.';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
